module.exports = __webpack_public_path__ + "static/media/medical_id_card@2x.1ad4c430.png";